export const GET_LOCATION_UNITS_LIST_REQUEST = 'GET_LOCATION_UNITS_LIST_REQUEST';
export const GET_LOCATION_UNITS_LIST_SUCCESS = 'GET_LOCATION_UNITS_LIST_SUCCESS';
export const GET_LOCATION_UNITS_LIST_FAILURE = 'GET_LOCATION_UNITS_LIST_FAILURE';
export const GET_LOCATION_UNITS_LIST_APPEND = 'GET_LOCATION_UNITS_LIST_APPEND'; // For pagination
export const GET_LOCATION_UNITS_LIST_RESET = 'GET_LOCATION_UNITS_LIST_RESET'; // Reset on unmount

